module.exports = __webpack_public_path__ + "static/img/0.4d2dedcc.png";